import { Container, Grid, styled } from '@mui/material'
import { Card as BaseCard, Typography as BaseTypography } from '@chilecompra/react-kit/components'

export const Wrapper = styled(Container)``
export const GridWrapper = styled(Grid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.align};

  &.MuiGrid-item {
    margin: ${props => props.margin};
  }
`
export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]}

  &:hover{
    color: ${props => props.theme.palette.blue[35]}
  }

  &:visited{
    color: ${props => props.theme.palette.blue[50]}
  }
`
export const InlineLabel = styled('div')`
  color: ${props => props.theme.palette.blue[50]};
`
export const Exportable = styled('div')``

export const Card = styled(BaseCard)`
  &.MuiPaper-root {
    height: 90%;
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    cursor: ${props => (props.onClick ? 'pointer' : 'default')};
    min-height: 140px;
    text-align: center;

    & > * {
      display: grid;
      grid-template-rows: auto 18px;
      height: 100%;
      padding: 16px;
    }
  }
`

export const CardHeading = styled(BaseTypography)`
  &.MuiTypography-root {
    display: block;
    font-size: 16px;
    line-height: 20px;
    max-width: 225px;
    width: 100%;

    ${props => props.theme.breakpoints.up('sm')} {
      min-height: 40px;
    }
  }
`

export const CardAmount = styled(BaseTypography)`
  &.MuiTypography-root {
    align-items: center;
    background-color: ${props => props.theme.palette.brand.gray3};
    border-radius: 15px;
    color: ${props => props.theme.palette.gray[50]};
    display: inline-flex;
    padding: 3px 15px;
  }
`

export const CardMore = styled(BaseTypography)`
  &.MuiTypography-root {
    color: ${props => props.theme.palette.blue[50]};
  }
`

export const Strong = styled('strong')``
